// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B00k","comment":"styles_comment__3VHeQ"};